import { Redirect } from 'umi';

export default function IndexPage() {
  return <Redirect to="/home" />;
}
